module.exports = __webpack_public_path__ + "img/collaborate_56.a6085799.jpg";